import { ServiceFeaturesListType } from 'contexts/serviceContext';
import { TruckListResponse } from 'lib/api/getTruckList';
import { QuoteRequest } from 'types/QuoteRequest';
import { Maybe, MaybeUndef } from 'types/UtilityTypes';
import { LoadBuildingSuggestions } from 'types/suggestions/LoadBuildingSuggestions';
import { SuggestedQuoteChange } from 'types/suggestions/QuoteSuggestions';
import { isLoadBuildingSuggestionActionable } from 'utils/isLoadBuildingSuggestionActionable';
import { isQuoteRequestActionable } from 'utils/isQuoteRequestActionable';

/** True when the Quote view has actionable AI signals (QQ, LB, carrier quote preload, truck list). */
export function hasQuoteViewSuggestions(
  features: Pick<
    ServiceFeaturesListType,
    'isCarrierNetworkQuotingEnabled' | 'isTruckListEnabled'
  >,
  quoteSuggestions: Maybe<SuggestedQuoteChange[]>,
  loadBuildingSuggestions: Maybe<LoadBuildingSuggestions[]>,
  truckListResult: MaybeUndef<TruckListResponse>,
  quoteRequest: Maybe<QuoteRequest>
): boolean {
  const preloadedCarrierQuoteCount =
    features.isCarrierNetworkQuotingEnabled && quoteRequest?.carrierQuotes
      ? quoteRequest.carrierQuotes.filter((cq) => cq.suggestedQuote != null)
          .length
      : 0;

  return (
    !!quoteSuggestions?.some(isQuoteRequestActionable) ||
    !!loadBuildingSuggestions?.some(isLoadBuildingSuggestionActionable) ||
    (!!features.isTruckListEnabled && !!truckListResult) ||
    preloadedCarrierQuoteCount > 0
  );
}
